import axios from 'axios';
import { SERVICE_URLS } from './constants';
import { processErrorMessage } from './functions';
import { callAPI } from './network';

export const getToken = () => {
    return sessionStorage.getItem('token');
}

export const login = async (user, password, isRecoverPassword) => {

    const parameters = {
        Password: password,
        Login: user,
        IsRecoverPassword: isRecoverPassword
    }

    try {
        const response = await axios.post(
            SERVICE_URLS.ROOT + 'Security/GetToken',
            JSON.stringify(parameters), {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });
        
        if (response.data.employeeId) {
            //console.log(response.data);
            var date = new Date();
            date.setDate(date.getDate() + 1);

            sessionStorage.setItem('token', response.data.token);

            if(response.data.companies !== null){
                //Esto se hace con el fin de poder tener un mejor control en el caso de el usuario aplique para multicompañia
                response.data.companies.length > 1 && !isRecoverPassword ? sessionStorage.setItem('data-user', JSON.stringify(response.data)) : sessionStorage.setItem('user', JSON.stringify(response.data));
            }
            else
                sessionStorage.setItem('user', JSON.stringify(response.data));
            

            sessionStorage.setItem('tokenExpiration', date);

            if (response.data.token === null){
                return ({
                    message: response.data.errorMessage,
                });
            }else{
                return ({
                    message: 'Ok',
                });
            }

            
        }
        else {
            return ({
                message: processErrorMessage(response.data.errorMessage || ''),
            });
        }
    } catch (error) {

        return ({
            message: error,
        });
    }
}

export const logout = () => {
    sessionStorage.clear();
    window.location = "/";
}

export const getUser = () => {
    if (sessionStorage.getItem('user')) {
        return JSON.parse(sessionStorage.getItem('user'));
    }

    return null;
}

export async function getPermissions (employeeId, companyId){
   const data = await callAPI(
                        null, 
                        `Security/getPermissionsByEmployeeAndCompany?employeeId=${employeeId}&companyId=${companyId}`, 'get');
   return data;
}

export async function getAllAirportsByPermission (employeeId, companyId){
    const data = await callAPI(
                         null, 
                         `Security/getAllAirportsByPermission?employeeId=${employeeId}&companyId=${companyId}`, 'get');
    return data;
 }

 export async function getCurrentAreaByEmployee (employeeId){
    const data = await callAPI(
                         null, 
                         `Vacation/GetCurrentAreaByEmployee?employeeId=${employeeId}`, 'get');
    return data;
 }